"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityFeedFilters = exports.filterLabels = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const ActivityFeedContext_1 = require("./ActivityFeedContext");
const trackingIds = {
    filterCheckbox: 'activity_feed_v2-filters-filter_checkbox',
};
exports.filterLabels = {
    deviation: 'activity_feed-filters-deviation',
    deviationRisk: 'activity_feed-filters-deviation_risk',
    messages: 'activity_feed-filters-messages',
    updates: 'activity_feed-filters-updates',
    communication: 'activity_feed-internal_note',
    quotes: 'activity_feed-filters-quotes',
    users: 'activity_feed-filters-users',
    documents: 'activity_feed-filters-documents',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    wrapper: {
        width: '660px',
    },
    checkboxWrapper: {
        margin: 0,
        padding: theme.spacing(0, 2.75),
    },
    title: {
        marginBottom: theme.spacing(2),
    },
}));
const ActivityFeedFilter = ({ label, filterKey, selected, selectFilters, count = 0 }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const classes = useStyles();
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(silhouette_core_1.Checkbox, { color: "primary", name: filterKey, checked: selected, onChange: () => selectFilters(filterKey), "data-tracking-id": trackingIds.filterCheckbox }), label: `${translate(label)} ${count ? `(${count})` : ''}`, className: classes.checkboxWrapper }));
};
const ActivityFeedFilters = () => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const classes = useStyles();
    const { selectedFilters, selectFilters, filters, filtersCount } = (0, ActivityFeedContext_1.useActivityFeedState)();
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { m: "auto", mb: 4, textAlign: "center", className: classes.wrapper, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "subtitle1", className: classes.title, children: translate('activity_feed-filters-title') }), filters.map((filter) => ((0, jsx_runtime_1.jsx)(ActivityFeedFilter, { filterKey: filter, label: exports.filterLabels[filter], selected: !!selectedFilters[filter], selectFilters: selectFilters, count: filtersCount?.[filter] }, filter)))] }));
};
exports.ActivityFeedFilters = ActivityFeedFilters;
//# sourceMappingURL=ActivityFeedFilters.js.map